import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { INDENT_CONTENT_COMMAND, OUTDENT_CONTENT_COMMAND } from 'lexical';

export const useIndentations = () => {
  const [editor] = useLexicalComposerContext();

  const outdent = () => {
    editor.dispatchCommand(OUTDENT_CONTENT_COMMAND, undefined);
  };

  const indent = () => {
    editor.dispatchCommand(INDENT_CONTENT_COMMAND, undefined);
  };

  return {
    outdent,
    indent,
  };
};
